import React, { useState } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import { Tree } from 'primereact/tree';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import EkatteEdit from './EkatteEdit';

import tools from '../tools/tools';

const EstateEdit = (props) => {
    

    return (
        <>
            <div className="form-row">
                <div className="form-group col-md-6">
                    <label htmlFor="inputObjectName"><b>За обект:</b></label>
                    <input className="form-control" value={props.data.estateAddress} onChange={e => props.setValue("estateAddress", e.target.value)} readOnly={props.readonly} />
                </div>
                <div className="form-group col-md-6">
                    <label htmlFor="inputKadData"><b>Кадастрални данни УПИ, кв.:</b></label>
                    <input className="form-control" value={props.data.cadastreData} onChange={e => props.setValue("cadastreData", e.target.value)} readOnly={props.readonly} />
                </div>
            </div>
            <div className="form-group col-md-12">
                <label>Населено място</label>


                <EkatteEdit ekatteId={props.data.estateEkatteId} setValue={props.setValue} setValueId="estateEkatteId" readonly={props.readonly} />


            </div>
        </>

    );
}


export default EstateEdit;